import type { PatientProgramType } from '../types/entity/programType'

export const hasProgramType = (
  programTypes: PatientProgramType[] | null | undefined,
  programTypeValue: number
): boolean => {
  if (!programTypes) {
    return false
  }

  return programTypes.some(
    (programType) => Number(programType.value) === programTypeValue
  )
}
